// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"65ba56d3","98":"8e2deedd","147":"a5969174","171":"f5fccc29","363":"10a2db0b","374":"cc4252f4","429":"fa2732f0","466":"d2a218c5","507":"c2055f4e","780":"32b8fa0a"}[chunkId] + ".chunk.js";
};